// extracted by mini-css-extract-plugin
export default {"main":"b3829c3ccc","tit":"_0d6a45dae2","maintitle":"_15194d98ed","ylw":"_3f98940ace","white":"c560e474f4","mv_title":"c820575ebf","mv_nc":"c78761645f","mv_in":"_74d4a1ca70"};